import { UserDto } from '../interfaces/users';
import { GroupsGlobalDto, ServiceDto } from '../interfaces';

export class Action {
  public action: ActionDetail;
  public mailId?: number;
  public messageNoBreak?: string;
  public objetNoBreak?: string;
  public objet?: string;
  public contact?: UserDto = undefined;
  public serviceProprietaireId?: number;
  public typeEntrantSortant?: string;

  constructor(
    data?: Partial<Action>,
    users?: UserDto[],
    typeOfAction?: 'All' | 'ToDo' | 'Done' | 'AskedByMe' | 'AssignedToMyTeam',
    services?: ServiceDto[],
    groups?: GroupsGlobalDto[]
  ) {
    Object.assign(this, data);
    this.messageNoBreak = this.action.message;
    this.objetNoBreak = this.objet;
    this.action.typeOfAction = typeOfAction;

    if (users?.length > 0) {
      // récupération du transmissionUserName
      let transmissionUser = null;
      transmissionUser = users.filter((x) => x.userId === this.action.transmissionUserId);
      if (transmissionUser.length > 0) {
        this.action.transmissionUserName =
          (transmissionUser[0].contactForUser.prenom ? transmissionUser[0].contactForUser.prenom : '') +
          ' ' +
          (transmissionUser[0].contactForUser.nom ? transmissionUser[0].contactForUser.nom : '');
      } else {
        this.action.transmissionUserName = ' ';
      }

      // récupération du nom de contact lié à contactiAdminId
      let actionUser = null;
      actionUser = users.find((user) => user.contactForUser?.contactId === this.action.contactiAdminId);
      if (actionUser) {
        this.action.contactName =
          (actionUser.contactForUser.prenom ? actionUser.contactForUser.prenom : '') +
          ' ' +
          (actionUser.contactForUser.nom ? actionUser.contactForUser.nom : '');
        // CDV-355 : display contactIdiAdmin (user that did the action) for group and service
        this.action.serviceUserName = this.action.contactName;
        this.action.groupUserName = this.action.contactName;
      } else {
        this.action.contactName = ' ';
        // CDV-355 : display contactIdiAdmin (user that did the action) for group and service
        this.action.serviceUserName = null;
        this.action.groupUserName = null;
      }
      this.contact = users.find((user) => user.contactForUser?.contactId === this.action.contactiAdminId);
    }

    if (services?.length && this.action.serviceId) {
      const serviceFound = services.find((service) => service.id === this.action.serviceId);
      this.action.name = serviceFound?.description;
    }

    if (groups?.length && this.action.groupeId) {
      const groupFound = groups.find((group) => group.id === this.action.groupeId);
      this.action.name = groupFound?.description;
    }
  }
}

export class ActionDetail {
  accuseDeReponse?: boolean;
  action?: string;
  canBeTransformInAction?: boolean;
  canUserTreatAction?: boolean;
  contactId?: number;
  contactName?: string;
  contactiAdminId?: number;
  commentaires?: string;
  echeance?: string;
  echeanceDateOrderUnix?: string;
  fontBold?: boolean;
  foreColor?: string;
  groupeId?: number;
  groupUserName?: string | null;
  id?: number;
  isAction?: boolean;
  isService?: boolean;
  isGroupe?: boolean;
  libre?: string;
  mailId?: number;
  message?: string;
  name?: string;
  nom?: string;
  objet?: string;
  prenom?: string;
  principal?: boolean;
  recipientAddress?: string;
  recipientType?: string;
  reponse?: string;
  rights?: {
    canBeTransformInAction: boolean;
    canDelete: boolean;
    canReply: boolean;
  };
  serviceDestinataireId?: number;
  serviceProprietaireId?: number;
  serviceId?: number;
  serviceUserName?: string | null;
  statut?: string;
  traiteLe?: string;
  transmisDate?: string;
  transmisDateOrderUnix?: number;
  transmissionUserId?: number;
  transmissionUserName?: string;
  type?: string;
  typeReponse?: number;
  typeOfAction?: 'All' | 'ToDo' | 'Done' | 'AskedByMe' | 'AssignedToMyTeam';
  user?: { id: number; login: string; active: boolean };
  workflowActivityId?: string;
  workflowActivityInstanceId?: string;
  workflowInstanceId?: string;
}
